module.exports = __webpack_public_path__ + "img/1762863292342-Qi820qZO.2f7ffbf8.png";